import * as React from "react";
import {OnFailure, OnSuccess} from "../../../../../store/action/actionHelpers";
import {connect} from "react-redux";
import {Dispatch} from "redux";
import Toast from "../../../../helper/Toast";
import Task from "../../../../../model/task/Task";
import EditTaskFormView from "./EditTaskFormView";
import {updateTask} from "../../../../../store/action/task/task";

interface IComponentProps {
	/**
	 * On successful created task callback.
	 */
	onSuccess: () => void;
	/**
	 * On cancel button click.
	 */
	onCancel: () => void;
	/**
	 * Task to edit
	 */
	task: Task;
}

interface IDispatchProps {
	/**
	 * Update task.
	 * @param {Task} data
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	updateTask: (data: Task, onSuccess: OnSuccess, onFailure: OnFailure) => void;
}

interface IState {
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
}

type Props = IComponentProps & IDispatchProps

class EditTaskForm extends React.PureComponent<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {isSubmitting: false,};
		this.onSubmit = this.onSubmit.bind(this);
		this.onSubmitSuccess = this.onSubmitSuccess.bind(this);
	}

	render() {
		return (
			<EditTaskFormView onSubmit={this.onSubmit}
							  onCancel={this.props.onCancel}
							  isSubmitting={this.state.isSubmitting}
							  task={this.props.task}/>
		);
	}

	onSubmit(data: Task) {
		this.setState({isSubmitting: true}, () => {
			this.props.updateTask(data, this.onSubmitSuccess,
				() => this.onSubmitFailure("Task update failed")
			);
		});
	}

	onSubmitSuccess() {
		this.setState({isSubmitting: false}, () => {
			Toast.success("Task updated", "Task update");
			this.props.onSuccess();
		});
	}

	onSubmitFailure(text: string) {
		this.setState({isSubmitting: false}, () => Toast.error(text, "Task update"));
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>, props: IComponentProps) {
	return {
		updateTask: (data: Task, onSuccess: OnSuccess, onFailure: OnFailure) =>
			dispatch(updateTask(props.task.id, data, onSuccess, onFailure))

	};
}

export default connect(null, mapDispatchToProps)(EditTaskForm);